export default __webpack_public_path__ + "static/media/default-per-area.a2754cc7.png";